

export const transformDropdownOptionsToObject =  options => {
    if(Array.isArray(options)) {
        return Object.assign(
            {},
            ...options.map(({ value, text }) => ({
                [value]: text
            }))
        );
    } else {
        return {};
    }
};